import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const CancelMapIcon = ({ className }) => (
  <SvgIcon width="20" height="20" viewBox="0 0 20 20" className={className}>
    <path d="M5.33327 15.5448L4.45508 14.6666L9.12174 9.99993L4.45508 5.33327L5.33327 4.45508L9.99993 9.12174L14.6666 4.45508L15.5448 5.33327L10.8781 9.99993L15.5448 14.6666L14.6666 15.5448L9.99993 10.8781L5.33327 15.5448Z" fill="#333945"/>
  </SvgIcon>
);

export default CancelMapIcon;
